<template>
  <div class="forget-box">
    <span style="color:#fff;">（该页面显示独立部署用户基本信息，安装包下载等）</span>
    <br />
    <span style="color:#fff;">用户名：{{username}}</span>
    <br />
    <span style="color:#fff;">客户名：{{clientname}}</span>
    <br />
    <span style="color:#fff;">
      安装包：
      <a href="http://test.zip" target="_blank">下载</a>
    </span>
    <br />
    <span style="color:#fff;">部署时间：-</span>
    <br />
    <a style="color:#fff;" @click="handleLogOut">退出</a>
    <br />
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: "",
      clientname: ""
    };
  },
  created() {
    this.username = this.$store.state.user.name;
    this.clientname = this.$store.state.user.clientName;
  },
  methods: {
    handleLogOut() {
      this.$store.dispatch("LogOut");
    }
  }
};
</script>
<style scoped>
</style>